export default __webpack_public_path__ + "static/media/ros.b4b50846.png";